// extracted by mini-css-extract-plugin
module.exports = {"border":"motivator_border__n3SWD","emojiBlock":"motivator_emojiBlock__f8sEz"};